<script lang="ts">
import {defineComponent} from 'vue'
import MediaGalleryFilter from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryFilter.vue";
import GlobalTabs from "@global/global-elements/global-tabs/global-tabs.vue";
import MediaGalleryList from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryList.vue";
import MediaGalleryActionBar from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryActionBar.vue";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox.vue";
import MediaGalleryNavigation from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryNavigation.vue";
import {mapGetters} from "vuex";
import MediaGalleryListActions from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryListActions.vue";

export default defineComponent({
    name: "MediaGallerySearchView",
    components: {
        MediaGalleryListActions,
        MediaGalleryNavigation, GlobalInputCheckbox, GlobalButton, MediaGalleryActionBar, MediaGalleryList, GlobalTabs, MediaGalleryFilter
    },
    computed: {
        ...mapGetters({
            keyword: 'getKeyword',
            filters: 'getFilters',
            assets: 'getAssets',
            hasSelectedAssets: 'hasSelectedAssets',
            getSelectedAssetIds: 'getSelectedAssetIds'
        }),
        selectedAll() {
            return this.assets.length === 0 ? false : this.assets.length === this.getSelectedAssetIds.length
        },
        isEmpty() {
            return this.assets.length === 0
        },
        requestRunning() {
            return this.$store.getters.hasRunningRequest('download') || this.$store.getters.hasRunningRequest('collection')
        }
    },
    methods: {
        handleKeywordChange(keyword: string) {
            this.$store.dispatch('setKeyword', keyword)
        },
        handleFilterChange(keyword: string) {
            this.$store.dispatch('setKeyword', keyword)
        },
        handleSelectAll(checked: boolean) {
            this.$store.dispatch('selectAllAssets', checked)
        },
        handleDownload() {
            this.$store.dispatch('downloadSelectedAssets')
        },
        handleCollection() {
            this.$store.dispatch('addToCollection')
        }
    }
})
</script>

<template>
    <div>
        <media-gallery-navigation/>
        <media-gallery-filter :keyword="keyword" :filters="filters" @keyword="handleKeywordChange" @filter="handleFilterChange"/>
        <media-gallery-list/>
        <media-gallery-action-bar>
            <template v-slot:actions>
                <global-button icon="download" :disabled="!hasSelectedAssets || requestRunning" @click="handleDownload">{{ $t('mediaGallery.actions.downloadSelected') }}</global-button>
                <global-button icon="collection-add" theme="secondary" :disabled="!hasSelectedAssets || requestRunning" @click="handleCollection">{{ $t('mediaGallery.actions.addToCollection') }}</global-button>
                <div>
                    <global-input-checkbox :label="$t('mediaGallery.actions.selectAll')" :value="selectedAll" @input="handleSelectAll" :disabled="isEmpty || requestRunning"/>
                </div>
            </template>
        </media-gallery-action-bar>
    </div>
</template>
